import { cn } from '@shared/utils';
import { formatGrams } from '@diet/utils';

export interface MacroRowProps {
  macros: { proteinG: number; fatG: number; carbsG: number };
  /** 三項巨量營養素都沒填的筆數；大於 0 時總量不完整 */
  missingCount: number;
  className?: string;
}

const ITEMS = [
  { key: 'protein', label: '蛋白質', pick: (m: MacroRowProps['macros']) => m.proteinG },
  { key: 'fat', label: '脂肪', pick: (m: MacroRowProps['macros']) => m.fatG },
  { key: 'carbs', label: '碳水', pick: (m: MacroRowProps['macros']) => m.carbsG },
] as const;

/**
 * 當日三大營養素總量。
 *
 * 放在總覽卡而非每一筆：追蹤營養素的人在意的是「今天蛋白質夠不夠」，
 * 不是「這一餐幾克」。單筆的數值直接列在 EntryRow 第二行。
 *
 * 不加顏色標記：畫面上沒有需要對照圖例的元素，色點只是裝飾。
 */
export function MacroRow({ macros, missingCount, className }: MacroRowProps) {
  return (
    <div className={cn('flex flex-col gap-1.5 border-t border-border pt-3', className)}>
      <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1.5">
        {ITEMS.map(({ key, label, pick }) => (
          <div key={key} className="flex items-baseline gap-1.5 text-xs">
            <span className="text-muted-foreground">{label}</span>
            <span className="font-mono tabular-nums">
              {formatGrams(pick(macros))}
              <small className="ml-0.5 text-[0.625rem] text-muted-foreground">g</small>
            </span>
          </div>
        ))}
      </div>

      {/*
        沒有這一行，五筆裡有三筆沒資料時畫面仍顯示「蛋白質 82g」，使用者會據此決定晚餐 ——
        那比不顯示更糟。缺漏為 0 時不渲染，正常情況下不佔版面。
      */}
      {missingCount > 0 && (
        <p className="text-[0.6875rem] text-muted-foreground">
          {missingCount} 筆未含營養素，總量不完整
        </p>
      )}
    </div>
  );
}
